import React, { FunctionComponent } from 'react'

import { ISizedBox } from './SizedBoxComponent.types'
import { Container } from './styles'

const SizedBox: FunctionComponent<ISizedBox> = ({ size }) => {
  return <Container data-testid="tst-sized-box" size={size} />
}

export default SizedBox
